/**
 * @generated SignedSource<<cebda490f15d2c0ba62ea364ead53650>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type HasForm = "HAS_FORM" | "NO_FORM" | "%future added value";
export type QueryMatch = "EQUAL_MATCH" | "INCLUDING_MATCH" | "PREFIX_MATCH" | "%future added value";
export type UrlMatch = "EQUAL_TYPE" | "HAS_ID_TYPE" | "EQUAL_OR_HAS_ID_TYPE" | "STARTS_WITH_PREFIX_MATCH" | "REGEX_MATCH_TYPE" | "%future added value";
export type UpdateFunnelInput = {
  clientMutationId?: string | null;
  funnelId: string;
  name?: string | null;
  isExperiment: boolean;
  landingPageAttributes?: PageAttributes | null;
  formPageAttributes?: ReadonlyArray<PageAttributes> | null;
  confirmPageAttributes?: PageAttributes | null;
  thanksPageAttributes?: PageAttributes | null;
};
export type PageAttributes = {
  id?: string | null;
  name: string;
  url: string;
  mobileUrl?: string | null;
  tabletUrl?: string | null;
  hasForm?: HasForm | null;
  urlMatchType: UrlMatch;
  queryMatchType?: QueryMatch | null;
  isEnableWhiteout?: boolean | null;
  isSpa?: boolean | null;
  pageUrlRegex?: string | null;
};
export type FunnelEditFormContainer_Mutation$variables = {
  input: UpdateFunnelInput;
};
export type FunnelEditFormContainer_MutationVariables = FunnelEditFormContainer_Mutation$variables;
export type FunnelEditFormContainer_Mutation$data = {
  readonly updateFunnel: {
    readonly funnel: {
      readonly id: string;
      readonly slug: string;
      readonly name: string;
      readonly isExperiment: boolean;
      readonly landingPage: {
        readonly id: string;
        readonly name: string;
        readonly url: string;
        readonly mobileUrl: string | null;
        readonly tabletUrl: string | null;
        readonly hasForm: HasForm | null;
        readonly urlMatchType: UrlMatch;
        readonly queryMatchType: QueryMatch;
        readonly isEnableWhiteout: boolean;
        readonly isSpa: boolean;
        readonly pageUrlRegex: string | null;
      } | null;
      readonly thanksPage: {
        readonly id: string;
        readonly name: string;
        readonly url: string;
        readonly mobileUrl: string | null;
        readonly tabletUrl: string | null;
        readonly urlMatchType: UrlMatch;
        readonly queryMatchType: QueryMatch;
        readonly isEnableWhiteout: boolean;
        readonly isSpa: boolean;
        readonly pageUrlRegex: string | null;
      } | null;
      readonly confirmPage: {
        readonly id: string;
        readonly name: string;
        readonly url: string;
        readonly mobileUrl: string | null;
        readonly tabletUrl: string | null;
        readonly urlMatchType: UrlMatch;
        readonly queryMatchType: QueryMatch;
        readonly isEnableWhiteout: boolean;
        readonly isSpa: boolean;
        readonly pageUrlRegex: string | null;
      } | null;
      readonly formPage: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
        readonly url: string;
        readonly mobileUrl: string | null;
        readonly tabletUrl: string | null;
        readonly urlMatchType: UrlMatch;
        readonly queryMatchType: QueryMatch;
        readonly isEnableWhiteout: boolean;
        readonly isSpa: boolean;
        readonly pageUrlRegex: string | null;
      }> | null;
    } | null;
  } | null;
};
export type FunnelEditFormContainer_MutationResponse = FunnelEditFormContainer_Mutation$data;
export type FunnelEditFormContainer_Mutation = {
  variables: FunnelEditFormContainer_MutationVariables;
  response: FunnelEditFormContainer_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mobileUrl",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tabletUrl",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlMatchType",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "queryMatchType",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isEnableWhiteout",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSpa",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pageUrlRegex",
  "storageKey": null
},
v11 = [
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/)
],
v12 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateFunnelPayload",
    "kind": "LinkedField",
    "name": "updateFunnel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Funnel",
        "kind": "LinkedField",
        "name": "funnel",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isExperiment",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Page",
            "kind": "LinkedField",
            "name": "landingPage",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasForm",
                "storageKey": null
              },
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Page",
            "kind": "LinkedField",
            "name": "thanksPage",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Page",
            "kind": "LinkedField",
            "name": "confirmPage",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Page",
            "kind": "LinkedField",
            "name": "formPage",
            "plural": true,
            "selections": (v11/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FunnelEditFormContainer_Mutation",
    "selections": (v12/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FunnelEditFormContainer_Mutation",
    "selections": (v12/*: any*/)
  },
  "params": {
    "cacheID": "826831734bdc4b31234640a83fd97b92",
    "id": null,
    "metadata": {},
    "name": "FunnelEditFormContainer_Mutation",
    "operationKind": "mutation",
    "text": "mutation FunnelEditFormContainer_Mutation(\n  $input: UpdateFunnelInput!\n) {\n  updateFunnel(input: $input) {\n    funnel {\n      id\n      slug\n      name\n      isExperiment\n      landingPage {\n        id\n        name\n        url\n        mobileUrl\n        tabletUrl\n        hasForm\n        urlMatchType\n        queryMatchType\n        isEnableWhiteout\n        isSpa\n        pageUrlRegex\n      }\n      thanksPage {\n        id\n        name\n        url\n        mobileUrl\n        tabletUrl\n        urlMatchType\n        queryMatchType\n        isEnableWhiteout\n        isSpa\n        pageUrlRegex\n      }\n      confirmPage {\n        id\n        name\n        url\n        mobileUrl\n        tabletUrl\n        urlMatchType\n        queryMatchType\n        isEnableWhiteout\n        isSpa\n        pageUrlRegex\n      }\n      formPage {\n        id\n        name\n        url\n        mobileUrl\n        tabletUrl\n        urlMatchType\n        queryMatchType\n        isEnableWhiteout\n        isSpa\n        pageUrlRegex\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7f6b3b8fec8f4211e41033f615daeadc";

export default node;
